import { getWindow } from "@faire/web/common/getWindow";

import { BAIT_IDS } from "./consts";
import { isElementVisible } from "./isElementVisible";

export const doesUserHaveAdblock = (): boolean =>
  !BAIT_IDS.map((id) => getWindow().document.getElementById(id)).every(
    isElementVisible
  );
